<style lang="scss" scoped>
td.future-cell {
  padding: 0;
  font-weight: bold;

  span {
    display: inline-block;
  }

  .settlement {
    font-size: 7rem;
  }

  .future-cell__empty {
    font-size: 4rem;
  }
}
</style>

<template>
  <td class="future-cell">
    <div
      v-if="data !== null"
      class="centered"
    >
      <div class="w-full centered">
        <span class="settlement">{{ formatPrice(data.settlement) }}</span>
      </div>
    </div>
    <div
      v-else
      class="centered future-cell__empty"
    >
      -
    </div>
  </td>
</template>

<script>
import { formatNumeral } from '@/helpers';

export default {
  name: 'FutureCell',
  props: {
    data: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  methods: {
    formatPrice(price) {
      if (price === null) {
        return '-';
      }

      if (price < 100) {
        return formatNumeral(price, 2);
      }

      return Math.round(price);
    },
  },
};
</script>
